import { render, staticRenderFns } from "./CertificationsTabEnrolments.vue?vue&type=template&id=41c5fa8d&"
import script from "./CertificationsTabEnrolments.vue?vue&type=script&lang=js&"
export * from "./CertificationsTabEnrolments.vue?vue&type=script&lang=js&"
import style0 from "./CertificationsTabEnrolments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports